'use client';

import { useTheme, useMediaQuery } from '@mui/material';
import { ArrowDownIcon } from '@/components/ui/icons/ArrowDown';
import { StyledScrollDownButton } from '@/components/ui/scroll/ScrollDownButton.styles';
import { useReducedMotion, scrollBehavior } from '@/utils/useReducedMotion';

export default function ScrollDownButton() {
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const reducedMotion = useReducedMotion();

  const handleClick = () => {
    window.scrollTo({ top: window.innerHeight - 64, behavior: scrollBehavior(reducedMotion) });
  };

  return (
    <StyledScrollDownButton aria-label='Scroll down' onClick={handleClick}>
      <ArrowDownIcon size={isSmUp ? 20 : 16} />
    </StyledScrollDownButton>
  );
}
